<div *ngIf="guestLeftNames.length > 0">
    <div class="message-container" *ngFor="let name of guestLeftNames; index as i">
        <div class="text-container">
            <div class="message-title">
                {{ 'access.message.user-left.title' | translate: { name } }}
            </div>
            <div class="text-message">
                {{ 'access.message.user-left.message' | translate: { name } }}
            </div>
        </div>

        <div class="buttons-container">
            <div class="reject button" (click)="closeMessage(i)">
                {{ 'access.message.user-left.button.close' | translate }}
            </div>
        </div>
    </div>
</div>
